<footer class="footer-container">
  <div class="footer-content">
    <img class="logo" src="assets/images/logos/Logotype.svg" />
  </div>
</footer>
